import { render, staticRenderFns } from "./ListVerifikasi.vue?vue&type=template&id=4b2c7dfb"
import script from "./ListVerifikasi.vue?vue&type=script&lang=js"
export * from "./ListVerifikasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports